import styled from "styled-components"

export const GamesheetPage = styled.div<{
    $loading: boolean
}>`
opacity: ${p => p.$loading ? 0 : 1};
transition: opacity 0.3s;
height: 100%;
`